/**
 * Where focus goes back to when a window closes and the control that opened it
 * can no longer take focus. A control inside a minimized window sits in an
 * inert subtree, so focus goes to that window's restore control instead, which
 * keeps the person where they were and brings the window back on Enter.
 */
export function windowFocusReturnTarget(trigger: HTMLElement | null | undefined): HTMLElement | null {
  if (!trigger?.isConnected) return null;
  if (!trigger.closest("[inert]")) return trigger;
  return trigger.closest("[data-window-root]")?.querySelector<HTMLElement>("[data-window-restore]") ?? null;
}
